// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import '@mdi/font/css/materialdesignicons.min.css'
import Notifications from '@kyvg/vue3-notification'
import VueCookies from 'vue-cookies'
import { App as CapacitorApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { isNavigationFailure, NavigationFailureType } from 'vue-router'
import { StatusBar, Style } from '@capacitor/status-bar'

createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(i18n)
  .use(Notifications)
  .use(VueCookies, { expires: '7d' })
  .mount('#app')

// iOS: overlay status bar + green CSS fill (see custom.scss). Style.Dark = white icons.
if (Capacitor.getPlatform() === 'ios') {
  document.documentElement.classList.add('ios-platform')
  StatusBar.setOverlaysWebView({ overlays: true }).catch(() => {})
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {})
}

// Handle deep links on native platforms
if (Capacitor.isNativePlatform()) {
  CapacitorApp.addListener('appUrlOpen', (event) => {
    const url = new URL(event.url)
    const path = url.pathname

    if (path && path !== '/') {
      router.push(path).catch((err) => {
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          console.error('Deep link navigation error:', err)
        }
      })
    }
  })
}
